export default "__VITE_ASSET__BYHaGh_t__"